<template>

    <div>
        <el-input class="input-reply" v-model="replyInput"
                      @keypress.enter.native="handleEnter"
            >
                <template #suffix
                          @click="handleEnter"
                >
                    <div class="suffix-send"></div>
                </template>
            </el-input>
            <div class="text-exist-caption mt4" v-if="errorMessage">
                {{ $t(errorMessage)}}
            </div>


        <button class="box-reply mt4"
                v-if="isOwner"
                @click="setReplyEditMode"
        >
            <div class="img-elbow" v-if="!isReplyEditMode"></div>
            <div class="text-reply" >
                {{isReplyEditMode ? $t('cancel_reply') : $t('add_reply') }}
            </div>
            <div
                    class="img-cancel"
                    v-if="isReplyEditMode"
            ></div>
        </button>
    </div>
</template>

<script>
import eventUtil from "@/components/event/eventUtil";
import alertMixins from "@/mixins/alertMixins";
import filterMixins from "@/mixins/filterMixins";
import listMixins from "@/mixins/listMixins";
import util from "@/mixins/util";
import EventBus from "@/utils/event-bus";
import EventDetailLink from "@/components/event/link/EventDetailLink.vue"
import eventValidator from "@/components/event/eventValidator";
const {filterConfig} = eventUtil;
import validateMixins from "@/mixins/validateMixins";

export default {
    name: "EventCommentReplyWriteComponent",
    mixins: [alertMixins, filterMixins, listMixins, eventUtil, eventValidator, validateMixins],
    components: {
        EventDetailLink,
    },
    inject: [],
    provide() {
        return {
        }
    },
    props: {
        eventKey: 0,
        eventCommentKey: 0,
        isOwner:false
    },
    data() {
        return {
            isRunning: false,
            isReplyEditMode: false,
            replyInput: '',
            writeApiParamSet: {
                type : 'post',
                wr_type:'comment',
            },
            writeFunc: 'createEventComment',
            parsingData: {
                replyInput : 'wr_content',
            },
            writeKeyName: 'wr_parent',
            writeSuccessMessage: "success_create_comment_reply",
        }
    },
    beforeRouterEnter() {
    },
    created() {

    },
    mounted() {

    },
    beforeUnmount() {

    },
    unmounted() {
    },
    computed: {},
    methods: {
        handleEnter(event){
            event.preventDefault();
            this.createCommentReply()
        },
        setReplyEditMode(event){
            event.preventDefault();
            this.replyInput = '';
            this.isReplyEditMode = !this.isReplyEditMode
        },

        makeParams(){
            let params = JSON.parse(JSON.stringify(this.writeApiParamSet));
            let dataArr = Object.keys(this.parsingData);
            dataArr.forEach(dataKey => {
                params[this.parsingData[dataKey]] = this[dataKey];
            })
            params[this.writeKeyName] = this.eventCommentKey
            params.e_idx = this.eventKey;
            return params;
        },
        async createCommentReply() {
            if (this.isRunning) {
                return false;
            }
            let validateResult = await this.$refs.eventCommentReplyForm.validate()
            let isSuccess = validateResult.valid;
            if(!isSuccess){
                return;
            }
            this.isRunning = true;
            let params = this.makeParams();
            try {
                this.$api.$board[this.writeFunc](params).then(res => res.Data.Result).then(res => {
                    if (!res.Info.status) {
                        EventBus.$emit('apiLoading', false);
                        this.isRunning = false;
                        this.errorAlert(this.$t('fail_create_comment_reply'));
                        return false;
                    } else {
                        this.writeAfterFunc();
                    }
                });

            } catch (e) {
                EventBus.$emit('apiLoading', false);
                this.isRunning = false;
                console.log(e);
            }
        },

        writeAfterFunc() {
            EventBus.$emit('apiLoading', false);
            this.createAlert({
                content: this.$t(this.writeSuccessMessage),
                hide: () => {
                    this.isReplyEditMode = false;
                    EventBus.$emit('getEventComment');
                }
            });
        },


    },
    watch: {},
}
</script>

<style scoped>

</style>
